import React, { createContext, useState, useEffect } from 'react';
import decode from 'jwt-decode'
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";


export const AuthContext = createContext();

const AuthContextProvider = (props) => {
  const [token, setToken] = useState('')
  const [isAuth, setIsAuth] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [user, setUser] = useState({})

  const loginUser = (token)=>{
    localStorage.setItem('app_token', token)
    const decoded = decode(token)
    setToken(token)
    setIsAuth(true)
    setUser(decoded)
  }

  const logoutUser = (user)=>{
    localStorage.removeItem('app_token')
    setToken({})
    setIsAuth(false)
    setUser(null)
  }

  const salir = () => {
    try {
      const storedToken = localStorage.getItem('app_token');
      if (!storedToken) return;
      const decoded = decode(storedToken);
      const dateNow = Math.floor(Date.now() / 1000);
      if (dateNow >= decoded.exp) {
        localStorage.removeItem('app_token');
        setToken('');
        setIsAuth(false);
        setUser(null);
        Swal.fire({
          position: 'center',
          icon: 'info',
          title: 'Tu sesión ha caducado',
          showConfirmButton: false,
          timer: 2000,
        });
        setTimeout(() => {
          window.location.href = '/Login';
        }, 2000);
      }
    } catch {
      localStorage.removeItem('app_token');
      setToken('');
      setIsAuth(false);
      setUser(null);
    }
  };

  useEffect(() => {
    const item = localStorage.getItem('app_token');
    if (item) {
      try {
        const decoded = decode(item);
        setToken(item);
        setIsAuth(true);
        setUser(decoded);
        salir();
      } catch {
        localStorage.removeItem('app_token');
      }
    }
    setIsLoading(false);
    const interval = setInterval(salir, 60000);
    return () => clearInterval(interval);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
        <AuthContext.Provider
      value={{
        token,
        isAuth,
        isLoading,
        user,
        loginUser,
        logoutUser,
      }}
      >
      { props.children }
    </AuthContext.Provider>
  )
};

export default AuthContextProvider;